var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1583 3.52729C12.4187 3.78764 12.4187 4.20975 12.1583 4.4701L4.15833 12.4701C3.89799 12.7305 3.47588 12.7305 3.21553 12.4701C2.95518 12.2098 2.95518 11.7876 3.21553 11.5273L11.2155 3.52729C11.4759 3.26694 11.898 3.26694 12.1583 3.52729Z",
    fill: "#1C2C40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21553 3.52729C3.47588 3.26694 3.89799 3.26694 4.15833 3.52729L12.1583 11.5273C12.4187 11.7876 12.4187 12.2098 12.1583 12.4701C11.898 12.7305 11.4759 12.7305 11.2155 12.4701L3.21553 4.4701C2.95518 4.20975 2.95518 3.78764 3.21553 3.52729Z",
    fill: "#1C2C40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.209585811d4de716ae4d2599f02ecc1d.svg";
export { ForwardRef as ReactComponent };